<template>
  <div class="question-container">
    <dropzone
      :options="dropzoneOptions"
      :dontSubstractMaxFiles="false"
      :destroyDropzone="false"
      @vdropzone-removed-file="removeFile"
      @vdropzone-success="imageUpload"
    />
    <span class="questionnaire-error-text" v-if="$v.message.$error">Dit is een verplicht veld.</span>
  </div>
</template>

<script>
import {
  required,
  minLength,
  between,
  requiredUnless
} from 'vuelidate/lib/validators'
import { EventBus } from '../EventBus'
import StatementField from './StatementField'
import Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'FileQuestion',
  components: {
    StatementField,
    Dropzone
  },
  props: {
    question: {
      type: Object,
      default: null
    }
  },
  computed: {
    isOptional () {
      return !this.question.typeable.required
    }
  },
  data () {
    return {
      statement: null,
      message: null,
      dropzoneOptions: {
        url: 'https://beta.enjoj-test.nl/api/questionnaire/files',
        maxFilesize: 3.0,
        addRemoveLinks: true,
        uploadMultiple: false,
        parallelUploads: 1,
        maxFiles: 250,
        dictDefaultMessage: 'Upload je bestanden'
      }
    }
  },
  validations: {
    message: {
      required: requiredUnless('isOptional')
    }
  },
  watch: {
    message (newMessage) {
      this.$v.$touch()

      let parsedAnswer = {
        id: this.question.id,
        answer: {
          questionId: this.question.id,
          answer: newMessage,
          statement: this.statement
        },
        ranged: false,
        valid: !this.$v.$invalid
      }
      this.$emit('updated', parsedAnswer)
    }
  },
  methods: {
    touch () {
      this.$v.$touch()
      let parsedAnswer = {
        id: this.question.id,
        answer: {
          questionId: this.question.id,
          answer: this.message,
          statement: this.statement
        },
        ranged: false,
        valid: !this.$v.$invalid
      }
      this.$emit('updated', parsedAnswer)
    },
    statementUpdated (newStatement) {
      this.statement = newStatement
      this.$emit('statementUpdated', {
        questionId: this.question.id,
        statement: this.statement
      })
    },
    imageUpload: function (file, response) {
      this.message = response
    },
    removeFile (file, error, xhr) {
      this.message = null
    }
  },
  created () {
    EventBus.$on('validate', this.touch)
  },
  beforeDestroy () {
    EventBus.$off('validate', this.touch)
  }
}
</script>
